import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { SessionStorageService } from '../util/session-storage.service';

import { Menu } from '@app/shared/models/api-response/outlet-timing-response';
import { CatalogApiResponse, OutletStatus } from '@app/shared/models/api-response/catalog-api-response';
import { UtilityService } from '../util/utility.service';

@Injectable({
    providedIn: 'root'
})
export class OutletStatusStripService {
    outletStatusStrip = new BehaviorSubject<OutletStatus | null>(null);

    constructor(
        private utilityService: UtilityService,
        private sessionStorageService: SessionStorageService
    ) {}

    hydrateOutletStatusStrip(outlet_status_strip: OutletStatus | null, menus: Menu[] = []) {
        this.outletStatusStrip.next(outlet_status_strip);
        this._removeAllStateOutletData(menus);
    }

    private _removeAllStateOutletData(menus: Menu[]) {
        menus.forEach(menu => {
            const { brand_id } = menu;
            const outletKey = `outlet_data_${brand_id}`;
            const outletData: CatalogApiResponse = this.sessionStorageService.get(outletKey);
            if (outletData && this._isStale(outletData, menu)) {
                this._removeOutletLastFetchedKey(`${outletKey}_last_fetched`);
            }
        });
    }

    private _isStale(outletData: CatalogApiResponse, menu: Menu): boolean {
        return this.utilityService.getOutletState(outletData.outlet) !== this.utilityService.getOutletState(menu);
    }

    private _removeOutletLastFetchedKey(key: string) {
        this.sessionStorageService.remove(key);
    }
}
